import type { User } from '~/modules/auth';
import type { Brand } from '~/modules/branding/types';

/**
 * Returns an object containing the properties that will be used to enrich the
 * Amplitued events (e.g. - '[Amplitude] Page Viewed').
 * @param brand - The Brand object to get information from.
 * @param user - The User object to get information from.
 */
export function getAmplitudeEventEnrichmentProperties(
  brand: Brand,
  user: User,
) {
  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  //
  //    ▄▄▄▖  ▗▖  ▗▖  ▗▄▄▖   ▗▄▖  ▗▄▄▖  ▗▄▄▄▖  ▗▄▖  ▗▖  ▗▖  ▗▄▄▄▖   ▐▌
  //     █    ▐▛▚▞▜▌  ▐▌ ▐▌ ▐▌ ▐▌ ▐▌ ▐▌   █   ▐▌ ▐▌ ▐▛▚▖▐▌    █     ▐▌
  //     █    ▐▌  ▐▌  ▐▛▀▘  ▐▌ ▐▌ ▐▛▀▚▖   █   ▐▛▀▜▌ ▐▌ ▝▜▌    █     ▐▌
  //    ▄█▄▖  ▐▌  ▐▌  ▐▌    ▝▚▄▞▘ ▐▌ ▐▌   █   ▐▌ ▐▌ ▐▌  ▐▌    █     ▗▖
  //
  //    These properties are tracked in all the Amplitude events that we want to
  //    enrich for ALL applications (e.g. - WMG1, ADA, etc.).
  //
  //    DO NOT REMOVE ANYTHING FROM HERE WITHOUT FIRST CHECKING WITH THE TEAM!
  //
  //    At a bare mininm ask in the relevant channel (#ada-wmg1-amplitude-collab)
  //    so that everyone is aware of the potential change.
  //
  //    These values are more than likely being used for analytics and any
  //    changes can have huge effects on the data being collected/reported.
  //
  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  return {
    product: brand.product,
    is_external: !user.isInternal,
  };
}
